import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CalendarPickerInput.scss";
import { getMonth, getYear } from "date-fns";
import { registerLocale } from "react-datepicker";
import hr from "date-fns/locale/hr";
import { useEffect, useState } from "react";
import { useId } from "react-id-generator";
registerLocale("hr", hr);

var startDateYear = `JAN ` + new Date().getFullYear().toString(),
  endDateYear = "MAY 2050";

var years = [];
for (var from = +startDateYear.slice(4), to = +endDateYear.slice(4); from <= to; from++)
  years.push(from);

const months = [
  "Siječanj",
  "Veljača",
  "Ožujak",
  "Travanj",
  "Svibanj",
  "Lipanj",
  "Srpanj",
  "Kolovoz",
  "Rujan",
  "Listopad",
  "Studeni",
  "Prosinac",
];

const CalendarPickerInput = ({
  name,
  setCalendar,
  calendar,
  isDateOnly = false,
  isRequired = false,
  disabled = false,
  placeholder,
}) => {
  const [labelHasTop, setLabelHasTop] = useState(false);
  const [isHoverActive, setIsHoverActive] = useState(false);
  const [generatedId] = useId();

  useEffect(() => {
    if (calendar) {
      setLabelHasTop(true);
    }
  }, [calendar]);

  const labelPositionCalculator = (param) => {
    if (calendar) {
      setLabelHasTop(true);
    } else if (param) {
      setLabelHasTop(true);
    } else {
      setLabelHasTop(false);
    }
  };

  useEffect(() => {
    var item = document.getElementById(generatedId);
    if (item) {
      item.addEventListener("mouseover", onMouseOverHandler, false);
      item.addEventListener("mouseout", onMouseLeaveHandler, false);
    }
  }, []);

  function onMouseOverHandler() {
    if (!labelHasTop) {
      setIsHoverActive(true);
    }
  }

  function onMouseLeaveHandler() {
    if (!labelHasTop) {
      setIsHoverActive(false);
    }
  }

  return (
    <>
      <div className="floating-label-wrap">
        <DatePicker
          id={generatedId}
          disabled={disabled}
          className={
            disabled
              ? "election-input-txt election-date input-field-disabled"
              : "election-input-txt election-date"
          }
          name={name}
          locale="hr"
          showTimeSelect={!isDateOnly}
          timeFormat={"HH:mm"}
          dateFormat={isDateOnly ? "dd/MM/yyyy" : "dd/MM/yyyy HH:mm"}
          timeIntervals={15}
          timeCaption={"Vrijeme"}
          onFocus={() => {
            labelPositionCalculator(true);
          }}
          onCalendarClose={() => {
            labelPositionCalculator(false);
          }}
          popperModifiers={[
            {
              name: "preventOverflow",
              options: {
                rootBoundary: "body",
                tether: false,
                altAxis: false,
              },
            },
          ]}
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div
              style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <select value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
                {years.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          )}
          selected={calendar}
          onChange={(date) => {
            // UTC to ISO with timezone conversion
            let tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
            let dateLocalISO = new Date(date - tzoffset).toISOString().slice(0, -1);
            if (dateLocalISO === "1970-01-01T01:00:00.000") {
              setCalendar(dateLocalISO);
            } else {
              setCalendar(dateLocalISO);
            }
          }}
        />
        <label
          className={
            labelHasTop
              ? "election-input-label top-is-70 is-size-4 is-election-date-placeholder-text-purple"
              : isHoverActive
              ? "election-input-label top-is-0 is-election-date-placeholder-italic is-size-4 calendar-placeholder-has-color-purple"
              : "election-input-label top-is-0 is-election-date-placeholder-italic is-size-4"
          }
          typeof="text"
          htmlFor="input1"
        >
          {placeholder}
          {isRequired ? <span className="has-text-danger ml-1">*</span> : ""}
        </label>
      </div>
    </>
  );
};

export default CalendarPickerInput;
